import { c as _c } from "react/compiler-runtime";
import { chakra, Heading, VStack } from '@chakra-ui/react';
import { RequestMatchExampleCard } from '@src/components/sco/RequestRoadmap/RequestMatchExampleCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
type RequestMatchExampleProps = {
  noOfMatches: string;
};
export const RequestMatchExample = props => {
  const $ = _c(10);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = isMobile ? "none" : "inline";
  let t1;
  if ($[0] !== t0) {
    t1 = <chakra.span display={t0}>Good news!</chakra.span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.noOfMatches) {
    t2 = <chakra.span bgColor="colorPalette.border" color="colorPalette.contrast" paddingX={2} paddingY={0.5} rounded="full">{props.noOfMatches}</chakra.span>;
    $[2] = props.noOfMatches;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Heading color="colorPalette.fg" size="sm" textAlign="center">{t1}{" We have"}{" "}{t2}{" "}potential matches for you.</Heading>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <VStack align="center" gap={2} justify="center" width="full">{InvestorMatchArray.map(_temp)}</VStack>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <VStack align="center" gap={4} justify="center" width="full" paddingY={10} borderRadius="xl">{t3}{t4}</VStack>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
const InvestorMatchArray = [{
  name: 'John Doe',
  title: 'Venture Capital',
  investorType: 'Venture Capital',
  location: 'Columbus',
  tags: ['Pre-Seed', 'Gaming', 'Mobile Apps'],
  matchScore: 95
}, {
  name: 'Jane Doe',
  title: 'Angel Investor',
  investorType: 'Angel Investor',
  location: 'San Francisco',
  tags: ['Pre-Seed', 'Healthcare', 'Biotech'],
  matchScore: 85
}, {
  name: 'Jim Doe',
  title: 'Venture Capital',
  investorType: 'Venture Capital',
  location: 'New York',
  tags: ['Pre-Seed', 'Software', 'AI'],
  matchScore: 75
}];
function _temp(investor, i) {
  return <RequestMatchExampleCard key={i} {...investor} />;
}